import { defineStore } from "pinia";
import { ref } from "vue";

export const useSignatureStore = defineStore("signature", () => {
	// data
	const signatureChannel = new BroadcastChannel("signature:status");
	const listeners = ref<{ [sig: string]: Function[] }>({});

	// methods
	function mounted() {
		signatureChannel.onmessage = ({ data: { sig, status } }) => {
			const successfully =
				(!status?.err && status?.confirmationStatus === "confirmed") ||
				status?.confirmationStatus === "finalized";

			if (successfully) {
				const [fn] = listeners.value[sig].splice(0, 1);
				if (!fn) return;

				fn();
				return;
			}

			const timeout = status?.confirmationStatus === "timeout";

			if (timeout) {
				const [fn] = listeners.value[sig].splice(0, 1);

				fn(new Error(status?.err))
				return
			}
		};
	}
	function addSignatureListener(sig: string, fn: Function) {
		listeners.value[sig] = listeners.value[sig] || [];
		listeners.value[sig].push(fn);
	}

	// setup
	mounted();

	return { addSignatureListener };
});
